import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { setGPSData, wsConnectionFailed, wsConnectionSuccessful } from '../actions';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { WS_URL } from '../../../configs';
import { getJSONFromString } from '../../../utils/utils';

window.wsConnection = null;
export default function* wsConnection(action) {
  const { dispatch } = window.appStore;
  try {
    if (!window.wsConnection) {
      window.wsConnection = new WebSocket(WS_URL);
      window.wsConnection.onopen = () => {
        dispatch(wsConnectionSuccessful());
      };

      window.wsConnection.onmessage = event => {
        const data = getJSONFromString(event.data) || {};
        dispatch(setGPSData(data));
        // dispatch(wsConnectionOnMessage(event.data));
      };

      window.wsConnection.onclose = event => {
        dispatch(wsConnectionFailed());
      };

      window.wsConnection.onerror = error => {
        window.console.error(error);
        dispatch(wsConnectionFailed());
      };
    }
  } catch (e) {
    yield put(wsConnectionFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
